import React, { useState, useEffect } from 'react';
import Link from 'next/link';

import { getRequest } from 'utils/api';
import { formatPrice } from 'utils/helpers';
import WalletIcon from 'public/icons/wallet.svg';
import Transactions from './wallet/Transactions';
import styles from 'styles/components/MiniWallet.module.scss';

const MiniWallet = () => {
  const [wallet, setWallet] = useState({});
  const [transactions, setTransactions] = useState([]);
  const [isLoading, setIsLoading] = useState({
    wallet: false,
    transactions: false,
  });

  useEffect(() => {
    setIsLoading(prevState => ({ ...prevState, wallet: true }));

    let isMounted = true;

    getRequest({
      endpoint: 'wallets/current',
    })
      .then(wallet => {
        if (!isMounted) return;
        setWallet(wallet);
        setIsLoading(prevState => ({ ...prevState, wallet: false }));
      })
      .catch(() => isMounted && setIsLoading(prevState => ({ ...prevState, wallet: false })));

    return () => (isMounted = false);
  }, []);

  useEffect(() => {
    if (!wallet.id) return;

    let isMounted = true;
    setIsLoading(prevState => ({ ...prevState, transactions: true }));

    getRequest({
      endpoint: `wallets/${wallet.id}/transactions`,
      query: { per_page: 3 },
    })
      .then(transactions => {
        if (!isMounted) return;
        setTransactions(transactions);
        setIsLoading(prevState => ({ ...prevState, transactions: false }));
      })
      .catch(() => isMounted && setIsLoading(prevState => ({ ...prevState, transactions: false })));

    return () => (isMounted = false);
  }, [wallet]);

  return (
    <div className={styles.wallet}>
      <div className={styles.header}>
        <h3>Wallet</h3>
      </div>

      <div className={styles.balanceBox}>
        <WalletIcon width={30} height={30} />
        {isLoading.wallet
          ? '---'
          : formatPrice(wallet.ready ? wallet.cached_true_balance : wallet.available_balance)}
      </div>

      <span className={styles.redText}>The minimum payout amount is $5</span>

      {transactions.length > 0 && (
        <>
          <div className={styles.transactions}>
            <div
              style={{ display: 'flex', justifyContent: 'space-between', margin: '20px 0 10px' }}
            >
              <h4>Latest transactions</h4>

              <Link href="/wallet" passHref>
                <span className="color-main cursor-pointer" style={{ fontSize: 12 }}>
                  View Wallet
                </span>
              </Link>
            </div>
          </div>

          {wallet.id && (
            <Transactions
              transactions={transactions}
              isLoading={isLoading.transactions}
              walletId={wallet.id}
              title=""
            />
          )}
        </>
      )}
    </div>
  );
};

export default MiniWallet;
